import { Category } from '../types/product';

export const CATEGORIES: Category[] = [
  {
    id: 'sneakers',
    name: '球鞋',
    description: '运动鞋和潮流球鞋',
    image: 'https://qlvpi37aqrajyh4x.public.blob.vercel-storage.com/products/categories/1-ltCpJXYCeWCQ2kCcAXuDcRbYorfRJq.jpg',
    order: 1,
    translations: {
      en: {
        name: 'Sneakers',
        description: 'Sports and trendy sneakers'
      }
    }
  },
  {
    id: 'clothing',
    name: '服饰',
    description: '潮流服装',
    image: 'https://qlvpi37aqrajyh4x.public.blob.vercel-storage.com/products/categories/1-ltCpJXYCeWCQ2kCcAXuDcRbYorfRJq.jpg',
    order: 2,
    translations: {
      en: {
        name: 'Clothing',
        description: 'Fashion clothing'
      }
    }
  }
];

// 尺码模板
export const SIZE_TEMPLATES = {
  clothing: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
  shoes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45'],
  oneSize: ['均码']
} as const;

// 对比模板
export const COMPARISON_TEMPLATES = {
  clothing: {
    original: {
      material: '原厂面料',
      craftsmanship: '原厂工艺'
    },
    replica: {
      material: '高级复刻面料',
      craftsmanship: '1:1还原工艺'
    }
  },
  sneakers: {
    original: {
      material: '原厂材质',
      craftsmanship: '原厂工艺'
    },
    replica: {
      material: '高级复刻材质',
      craftsmanship: '1:1还原工艺'
    }
  }
} as const; 